export const WHATSAPP_CHANNEL =
  "https://whatsapp.com/channel/0029VbBnIwR7j6fz5Zist31V";
export const WHATSAPP_PHONE = 7370947330;
export const WHATSAPP_MSG = "Jai shree shyam ji 🌹 \nNeed some information!";
export const WHATSAPP_URL = `https://api.whatsapp.com/send?phone=91${WHATSAPP_PHONE}&text=${encodeURIComponent(WHATSAPP_MSG)}`;
export const SWAYAM_QR_WHATSAPP = "919571974855";
export const SWAYAM_QR_WHATSAPP_MSG =
  "जय श्री श्याम जी, बाबा के दर्शन को आए है। स्वयं अर्जी और दर्शन में मदद चाहिए 🤗";
export const SWAYAM_QR_WHATSAPP_URL = `https://api.whatsapp.com/send?phone=${SWAYAM_QR_WHATSAPP}&text=${encodeURIComponent(SWAYAM_QR_WHATSAPP_MSG)}`;
export const SWAYAM_ARJEE_PHONE = 8769294874;
export const SWAYAM_ARJEE_URL = `https://wa.me/91${SWAYAM_ARJEE_PHONE}`;